import { render } from "./SurveyAdminList.vue?vue&type=template&id=550e8db1&ts=true"
import script from "./SurveyAdminList.vue?vue&type=script&lang=ts"
export * from "./SurveyAdminList.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\src\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__